import { Stack, Text } from '@mantine/core'
import type { CoverageEligibilityResponse } from '@medplum/fhirtypes'
import { formatDateTime } from '@/utils.ts'
import { getCoverageStatus, localizeDispositionTimestamps } from '@/utils/eligibilityStatus'

type CoverageEligibilityOutcomePanelProps = {
  latestEligibilityResponse: CoverageEligibilityResponse | null
  isEligibilityStale?: boolean
  className?: string
}

export function CoverageEligibilityOutcomePanel({
  latestEligibilityResponse,
  isEligibilityStale = false,
  className,
}: CoverageEligibilityOutcomePanelProps) {
  if (!latestEligibilityResponse) {
    return null
  }

  const coverageStatus = getCoverageStatus(latestEligibilityResponse)

  const color =
    coverageStatus === 'Active'
      ? 'border-green-200 bg-green-50'
      : coverageStatus === 'Not Active'
        ? 'border-red-200 bg-red-50'
        : 'border-purple-800 bg-purple-50'

  return (
    <Stack
      gap="sm"
      className={`${className} ${color} 'mt-4 max-h-100 overflow-y-auto rounded-md border p-4`}
    >
      <Text size="sm">
        <b>Status:</b> {coverageStatus}
      </Text>
      <Text size="sm">
        <b>Last check:</b>{' '}
        {formatDateTime(
          latestEligibilityResponse.meta?.lastUpdated || latestEligibilityResponse.created || '',
          '-',
          true,
        )}
      </Text>
      {isEligibilityStale && (
        <Text size="sm" c="orange">
          This eligibility result is stale because the insurance coverage changed after the last
          check.
        </Text>
      )}
      <div
        className="text-sm"
        dangerouslySetInnerHTML={{
          __html: localizeDispositionTimestamps(latestEligibilityResponse.disposition),
        }}
      />
    </Stack>
  )
}
